import { render, staticRenderFns } from "./Flash.vue?vue&type=template&id=dee1766c&"
import script from "./Flash.vue?vue&type=script&lang=ts&"
export * from "./Flash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports